  document.querySelectorAll('.transformations-swiper').forEach(item => {
    new Swiper(item, {
      loop: true,
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 5,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
        }
      }
    });
  });

// document.querySelectorAll('.cs-swiper-slider').forEach(item => {
//   new Swiper(item, {
//     loop: true,
//     slidesPerView: 3,
//     slidesPerGroup: 1,
//     spaceBetween: 24,
//      autoplay: {
//       delay: 5000,
//       disableOnInteraction: false
//     },  
//     breakpoints: {
//       0: {
//         slidesPerView: 1.1,
//         slidesPerGroup: 1,
//         centeredSlides: false
//       },
//       768: {
//         slidesPerView: 2.2,
//         slidesPerGroup: 1,
//         centeredSlides: false
//       },
//       1024: {
//         slidesPerView: 4.5,
//         slidesPerGroup: 1,
//       }
//     }
//   });
// });

document.querySelectorAll('.cs-swiper-slider').forEach(item => {
  new Swiper(item, {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 24,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },  
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        centeredSlides: false
      },
      768: {
        slidesPerView: 2.2,
        slidesPerGroup: 1,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 3.2,  // reduced
        slidesPerGroup: 1
      },      
      1500: {
        slidesPerView: 4.5,
        slidesPerGroup: 1
      }
    }
  });
});

document.querySelectorAll('button.cs-hs-btn').forEach(item => {
  item.addEventListener('click', function () {
    const parent = item.closest('.cs-main.without-slider');
    const hiddenBlocks = parent.querySelectorAll('.cs-block-wrap.hide');

    hiddenBlocks.forEach(el => el.classList.remove('hide'));

    item.remove();
  });
});


if (document.querySelector(".index-banner, .custom-banner-wrapper")) {
  document.body.classList.add("has_banner");
}